export const RTL_LANGUAGE = ['ar'];

export const COOKIE_NAME = 'cookie-consent';

export const FONT_BASE_URL = {
  ROW: 'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_fonts/',
  TTP: 'https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok_fonts/',
  'EU-TTP': 'https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok_fonts/',
};

export const CUSTOM_FONT_URLS = [
  ['tiktok-display-bold', 'TikTokDisplayFont-Bold.woff2?_default_font=1&v=2'],
  ['tiktok-display-regular', 'TikTokDisplayFont-Regular.woff2?_default_font=1&v=2'],
  ['tiktok-display-medium', 'TikTokDisplayFont-Semibold.woff2?_default_font=1&v=2'],
  ['tiktok-text-bold', 'TikTokFont-Bold.woff2?_default_font=1&v=2'],
  ['tiktok-text-regular', 'TikTokFont-Regular.woff2?_default_font=1&v=2'],
  ['tiktok-text-medium', 'TikTokFont-SEMIBOLD.woff2?_default_font=1&v=2'],
];

export const closeIconSvg =
  '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M21.1718 23.9999L10.2931 13.1212C9.90261 12.7307 9.90261 12.0975 10.2931 11.707L11.7074 10.2928C12.0979 9.90228 12.731 9.90228 13.1216 10.2928L24.0002 21.1715L34.8789 10.2928C35.2694 9.90228 35.9026 9.90228 36.2931 10.2928L37.7073 11.707C38.0979 12.0975 38.0979 12.7307 37.7073 13.1212L26.8287 23.9999L37.7073 34.8786C38.0979 35.2691 38.0979 35.9023 37.7073 36.2928L36.2931 37.707C35.9026 38.0975 35.2694 38.0975 34.8789 37.707L24.0002 26.8283L13.1216 37.707C12.731 38.0975 12.0979 38.0975 11.7074 37.707L10.2931 36.2928C9.90261 35.9023 9.90261 35.2691 10.2931 34.8786L21.1718 23.9999Z"></path></svg>';
export const infoIconSvg =
  '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M814.983529 404.781176a45.176471 45.176471 0 0 1 0 63.849412l-256 256a45.176471 45.176471 0 0 1-63.849411 0L239.134118 468.630588a45.176471 45.176471 0 0 1 63.849411-63.849412l224.075295 224.075295 224.075294-224.075295a45.176471 45.176471 0 0 1 63.849411 0z"></path></svg>';

export const verticalbarIconSvg = `<svg width="1" height="24" viewBox="0 0 1 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="0" y1="24" x2="0" stroke="#161823" stroke-opacity="0.12" stroke-width="1"/>
</svg>`;

export const EFFECTIVE_KEY = 'LOCAL_IS_EFFECTIVE';

export const DEFAULT_TEA_APP_ID = 345918;

export const DEFAULT_TEA_CONFIG = {
  channel: 'sg',
  channel_type: 'tcpy',
};
